import { css } from 'styled-components';

export const wrapper = () => css`
  min-width: 18rem;
`;
